/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import {
  Button,
  Heading,
  Progress,
  Stack,
  Text,
  FontAwesomeIcon,
} from "components";
import { useState } from "react";
import { useUI } from "state/UIContext";
import PassportImagePage from "./PassportImageInstructions/PassportImageInstructions";
import PersonalImageInstructions from "./PersonalImageInstructions/PersonalImageInstructions";
import { useTranslation } from "react-i18next";

const InstructionsPage = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const { closeModal } = useUI();
  return (
    <div className="w-full h-screen sm:h-[calc(100vh-100px)] max-w-6xl -bg--theme-colors-surface-neutral-level00 p-5">
      <div className="flex items-center mb-6 justify-between gap-x-2 sm:gap-x-0 pt-2 px-4">
        <Heading as="h2" className="-text--theme-colors-text-title">
          {t("instructions.title")}
        </Heading>
        <div>
          <Button variant="ghost-unstyled" size="xl" onClick={closeModal}>
            <div className="p-1">
              <FontAwesomeIcon name="fa-xmark" size="2x" />
            </div>
          </Button>
        </div>
      </div>
      <Stack className="overflow-y-auto h-[calc(100vh-120px)] sm:h-[calc(100vh-200px)] mt-2">
        <div className="flex sm:px-4 gap-x-4 mb-s50 w-full lg:px-40">
          <Stack
            className={cn("text-tertiary items-center", {
              "!text-secondary": +step === 1,
            })}
          >
            <Button fullWidth variant="ghost" onClick={() => setStep(1)}>
              <Text
                as="strong"
                className="whitespace-nowrap -text--component-colors-tab-active-default-high"
              >
                {t("instructions.tabs.personalPhoto")}
              </Text>
            </Button>
            <Progress value={+step === 1 ? "100" : 0} />
          </Stack>
          <Stack
            className={cn("text-tertiary items-center ", {
              "!text-secondary": +step === 2,
            })}
          >
            <Button fullWidth variant="ghost" onClick={() => setStep(2)}>
              <Text
                as="strong"
                className="whitespace-nowrap -text--component-colors-tab-active-default-high"
              >
                {t("instructions.tabs.passportPhoto")}
              </Text>
            </Button>
            <Progress value={+step === 2 ? "100" : 0} />
          </Stack>
        </div>
        {step === 1 && <PersonalImageInstructions />}
        {step === 2 && <PassportImagePage />}
      </Stack>
    </div>
  );
};

export default InstructionsPage;
